import request from ".";
import { STAGING_API } from "@/lib/constants";

export const homeApi = {
  getNews: (type?: string) =>
    request.post(`News/GetTop3ActiveNews?Type=${type ?? "All"}`),
  getPartners: () => request.post("Partners/getAllHomePartners15"),
  getGallery: () => request.post("Gallary/getAllGallary"),
  subscribeNewsletter: (email: string) =>
    request.post(`${STAGING_API}Academics/Subscribenewsletter?Email=${email}`),
  givingNewsletter: (email: string) =>
    request.post(`Academics/SubscribenFunRaising?Email=${email}`),
};
